import PropTypes from 'prop-types';
import styles from './FJVideoPreview.module.less';
import { useEffect, useState } from 'react';
import FJResourceItemLoading from '../../../../common/components/FJResourceItemLoading/FJResourceItemLoading.jsx';
import classNames from 'classnames';
import FJUtil from '../../../../util/FJUtil.js';
import FJRetry from '../../../../common/components/FJRetry/FJRetry.jsx';

const FJVideoPreview = props => {
    const { url, className } = props;
    const [videoUrl, setVideoUrl] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setVideoUrl(url);
    }, [url]);

    const _onLoadedData = () => {
        setIsLoading(false);
    };

    const _onLoadStart = () => {
        setIsError(false);
        setIsLoading(true);
    };

    const _onError = () => {
        setIsError(true);
        setIsLoading(false);
    };

    const _onRefresh = () => {
        setIsError(false);
        setIsLoading(true);
        setVideoUrl(FJUtil.getReloadNewUrl(url));
    };

    return (
        <div className={classNames(styles.box, className)}>
            <video
                src={videoUrl}
                autoPlay={true}
                muted
                controls={false}
                loop={true}
                onLoadedData={_onLoadedData}
                onLoadStart={_onLoadStart}
                onError={_onError}
            />
            {isLoading && <FJResourceItemLoading />}
            {isError && <FJRetry refreshCallback={_onRefresh} isShow={true} />}
        </div>
    );
};
FJVideoPreview.propTypes = {
    url: PropTypes.string,
    className: PropTypes.string,
};
export default FJVideoPreview;
